import styled from 'styled-components'

const OverlayContainerStyled = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`

const LoadingContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const LoadingTextStyled = styled.p`
  color: white;
  margin-top: 16px;
`

export { OverlayContainerStyled, LoadingContainerStyled, LoadingTextStyled }
